import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { DeletePublishedConnectionVersionsRequest } from '../../publishedConnection/serverApi/requests/DeletePublishedConnectionVersionsRequest';
import { GetPublishedConnectionVersionsRequest, GetPublishedConnectionVersionsResult } from '../serverApi/requests/GetPublishedConnectionVersionsRequest';
import { PublishedConnectionRevision } from '../serverApi/types/PublishedConnectionRevision';

export class PublishedConnectionRevisionsResource {
  private fetcher = new WebClientListResourceFetcher(GetPublishedConnectionVersionsRequest, (result: GetPublishedConnectionVersionsResult) => result.versions);

  public all(): ResourceQuery<PublishedConnectionRevision> {
    return new ResourceQuery(this.fetcher);
  }

  public del = (id: string): Promise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeletePublishedConnectionVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  };
}

export const PublishedConnectionRevisions = new PublishedConnectionRevisionsResource();
